import axios from "axios";

const apiBase = process.env.REACT_APP_API;

export const fetchAdminTabs = async () => {
  try {
    const token = localStorage.getItem("token");
    
    console.log('🔍 Token from localStorage:', token);
    console.log('🔍 Token type:', typeof token);
    console.log('🔍 Token is null?', token === null);
    console.log('🔍 Token is undefined?', token === undefined);

    if (!token) {
      console.warn("⚠️ No token found in localStorage");
      throw new Error("Authentication token not found. Please login again.");
    }

    const authHeader = `Bearer ${token}`;
    console.log('📝 Auth header being sent:', authHeader);
    console.log('📝 Auth header length:', authHeader.length);

    const response = await axios.get(
      `${apiBase}/admin/tabs`,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
    
    console.log("✅ Tabs fetched successfully:", response.data);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || "Failed to fetch admin tabs";
    console.error("❌ Error fetching admin tabs:", errorMessage);
    throw new Error(errorMessage);
  }
};
